const transitions = {
    hoverDefault: "all 250ms ease-out",
}

export default transitions
